import { render } from "./MediaUploadOptions.vue?vue&type=template&id=69594228"
import script from "./MediaUploadOptions.vue?vue&type=script&lang=js"
export * from "./MediaUploadOptions.vue?vue&type=script&lang=js"
script.render = render

export default script